// Formatting and syntax highlighting for the HTML code view, downloads and the profile JSON.
import beautify from "js-beautify";
import hljs from "highlight.js/lib/core";
import xml from "highlight.js/lib/languages/xml";
import json from "highlight.js/lib/languages/json";

hljs.registerLanguage("xml", xml);
hljs.registerLanguage("json", json);

export function formatHtml(html) {
  return beautify.html(html, {
    indent_size: 2,
    wrap_line_length: 0,
    preserve_newlines: false,
    end_with_newline: false,
    extra_liners: [],
  });
}

// For display only: downloads and copies always keep the full image data.
export function shortenDataUris(html) {
  return html.replace(/data:([\w/+.-]+);base64,([A-Za-z0-9+/=]+)/g, (whole, type, data) =>
    data.length < 120 ? whole : `data:${type};base64,…(${Math.max(1, Math.round((data.length * 3) / 4 / 1024))} KB)`);
}

export function formatJson(value) {
  return `${JSON.stringify(value, null, 2)}\n`;
}

export function highlight(code, language) {
  return hljs.highlight(code, { language: language === "html" ? "xml" : "json", ignoreIllegals: true }).value;
}
